/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCampingTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCampingTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Go Camping!",
    "Outdoor Adventure Awaits!",
    "Nature Calls!",
  ],
  title: "Camping Trip",
  description: "Plan an adventurous camping trip.",
  longDescription:
    "Gather your friends for a fun camping trip. Choose a date, select a campsite, and decide on food and activities to enjoy!",
  emoji: "⛺",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Camping Trip",
          emoji: "⛺",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go camping?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a campsite?",
            description: "Which campsite should we choose for our adventure?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "Where should we camp?",
                emoji: "🏕",
                completeAction: {
                  question: "Decide on food and activities?",
                  description:
                    "What food and activities should we plan for the trip?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What food should we bring?",
                      emoji: "🍔",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we do?",
                      emoji: "🎣",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Time for Adventure!",
    outroDescription:
      "Your camping trip plans are set! Enjoy the great outdoors!",
  },
};
